import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'mapfre-auditmap/src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { CacheService, IExternalCompanyBO } from '@mapfre-tech/amap3';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BusinessService {

  className = 'BusinessService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  // external-businesses

  getAllExternalBusiness(cache = true, cacheKey = "allExternalBusiness"): Observable<IExternalCompanyBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<IExternalCompanyBO[]>;
    } else {
      const observable = this.http.get<IExternalCompanyBO[]>(environment.base_URL + "/external-companies").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  newExternalBusiness(business: IExternalCompanyBO) {
    return this.http.post(environment.base_URL + "/external-companies", business)
  }

  updateExternalBusiness(business: IExternalCompanyBO, id: number) {
    return this.http.put(environment.base_URL + `/external-companies/${id}`, business)
  }

}
